export const menuKeywordStyle = theme => ({
    paddingTop: {
        paddingTop: '70px',
    },
    containerTextAndMark: {
        display: 'flex',
        flexDirection: 'row'
    },
    mark: {
        height: '27px',
        width: '3px',
        marginRight: '12px',
        backgroundColor: '#007AFF'
    },
    isTextChecked: {
        color: '#007AFF'
    },
    isTextNoChecked: {
        color: '#6f6f6f'
    },
    cursorPointer: {
        cursor: 'pointer'
    }
})